import React, { useState, useEffect, useCallback } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { supportApi } from "../services/supportApi";
import SupportTicketList from "../components/support/SupportTicketList";
import SupportChat from "../components/support/SupportChat";
import { useTranslation } from "react-i18next";

const SupportPage = () => {
  const { t } = useTranslation();
  const [tickets, setTickets] = useState([]);
  const [selectedId, setSelectedId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [unreadPerTicket, setUnreadPerTicket] = useState({});

  const fetchTickets = useCallback(async () => {
    try {
      const res = await supportApi.getTickets();
      setTickets(res.data.tickets || []);
    } catch {
      // silently fail — user sees empty state
    } finally {
      setLoading(false);
    }
  }, []);

  const fetchUnread = useCallback(async () => {
    try {
      const res = await supportApi.getUnreadCount();
      setUnreadPerTicket(res.data.per_ticket || {});
    } catch {}
  }, []);

  useEffect(() => {
    fetchTickets();
  }, [fetchTickets]);

  useEffect(() => {
    fetchUnread();
    const id = setInterval(fetchUnread, 30000);
    return () => clearInterval(id);
  }, [fetchUnread]);

  const handleNewTicket = async (subject, body) => {
    const res = await supportApi.createTicket(subject, body);
    await fetchTickets();
    setSelectedId(res.data.ticket_id);
  };

  const handleSelect = useCallback(async (ticketId) => {
    setSelectedId(ticketId);
    try {
      await supportApi.markRead(ticketId);
      setUnreadPerTicket((prev) => ({ ...prev, [ticketId]: 0 }));
    } catch {}
  }, []);

  return (
    <Container fluid className="px-0" style={{ height: "calc(100vh - 56px)", overflow: "hidden" }}>
      <Row className="h-100 g-0">

        {/* Left panel: ticket list */}
        <Col xs={12} md={4} lg={3} style={{ borderRight: "1px solid #f3f4f6", height: "100%", overflowY: "auto", background: "#fff" }}>
          <SupportTicketList
            tickets={tickets}
            selectedId={selectedId}
            onSelect={handleSelect}
            onNewTicket={handleNewTicket}
            loading={loading}
            unreadPerTicket={unreadPerTicket}
          />
        </Col>

        {/* Right panel: chat */}
        <Col xs={12} md={8} lg={9} style={{ height: "100%", background: "#fff" }}>
          {selectedId ? (
            <SupportChat
              key={selectedId}
              ticketId={selectedId}
              isAdmin={false}
              onTicketUpdated={fetchTickets}
            />
          ) : (
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: "100%", gap: "8px" }}>
              <div style={{ fontSize: "32px", opacity: 0.2 }}>💬</div>
              <span style={{ fontSize: "13px", color: "#9ca3af" }}>{t("support.select_ticket")}</span>
            </div>
          )}
        </Col>
      </Row>
    </Container>
  );
};

export default SupportPage;
